<template>
  <div>
    <!-- 服务费弹窗 -->
    <van-popup v-model="visible" class="confirm-withdrawal-popup" :close-on-click-overlay="false">
      <div class="popup-body">
        <div class="popup-title">提示</div>
        <div class="info-text" v-if="detailData.cardNo">请确认您的银行卡信息，并验证身份：</div>
        <div class="info-text bank">
          <span>银行卡号：{{ detailData.cardNo || '未绑定' }}</span>
          <div class="text-btn" @click="jumpBankSet">{{ detailData.cardNo ? '变更' : '去绑定' }}</div>
        </div>
        <div class="info-text bank">
          <span>手机号：{{ detailData.mobile }}</span>
        </div>
        <div class="input-box" v-if="detailData.cardNo">
          <input type="text" placeholder="请您输入验证码" v-model="code" maxlength="6" />
          <div class="code-btn org" @click="checkCode" v-if="codeIndex == CODE_SIZE">获取验证码</div>
          <div class="code-btn" v-else>{{ codeIndex }}S</div>
        </div>
        <van-button v-if="detailData.cardNo" round class="close-btn" @click="visible = false">取消</van-button>
        <van-button v-if="detailData.cardNo" round class="submit-btn active" @click="submit">确认</van-button>
      </div>
    </van-popup>
    <validCodeModal ref="validCodeModal" @success="openTimer"></validCodeModal>
  </div>
</template>

<script>
import { common, codeTools } from '@/api/mixins';
import validCodeModal from '@/components/validCodeModal';
export default {
  components: { validCodeModal },
  mixins: [common, codeTools],
  data() {
    return {
      code: '',
      showPwd: false,
      detailData: {},
      visible: false,
      params: {}
    };
  },
  mounted() {},
  methods: {
    open(detailData = null, params = {}) {
      this.params = params;
      if (detailData) {
        this.detailData = detailData;
      } else {
        this.getBankInfo();
      }
      this.password = '';
      this.visible = true;
    },
    //获取银行卡信息
    getBankInfo() {
      this.loading = true;
      this.$http({
        type: 'GET',
        url: '/api/userWithdrawLog/read/info',
        data: {}
      })
        .then(res => {
          this.loading = false;
          this.detailData = res.data;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    submit() {
      if (!this.code) {
        this.$notice.msg('请输入验证码');
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$http({
        url: '/api/userCashWithdrawLog/okbWithdrawCheck',
        type: 'POST',
        data: {
          smsCode: this.code
        }
      })
        .then(res => {
          const params = {
            idempotentId: res.data.idempotentId,
            withdrawType: '1',
            ...this.params
          }
          if(typeof params.ids == 'string') {
            params.ids = params.ids.split(',');
          }
          this.$http({
            url: '/api/userCashWithdrawLog/okbWithdrawNew',
            type: 'POST',
            data: params
          })
            .then(res => {
              this.visible = false;
              this.$notice.msg('操作成功');
              this.$emit('reload');
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 打开短信验证码计时器
    openTimer(data) {
      this.codeId = data.codeId;
      this.timerStart();
    },
    // 发送验证码
    checkCode() {
      if (this.codeIndex != this.CODE_SIZE) {
        return;
      }
      this.$refs.validCodeModal.open({
        requestUrl: '/api/userCashWithdrawLog/sendCode',
        ajaxType: 'POST',
        params: {}
      });
    },
    // 跳转重置密码
    jumpBankSet() {
      sessionStorage.confirmWithdrawalPopup = 1;
      this.$emit('jumpBankSet');
      this.goPage('/apps/my/bankSet');
    }
  }
};
</script>

<style lang="scss" scoped>
@import './confirmWithdrawalPopup.scss';
</style>